import styled, { css } from 'styled-components';
import { Image, GenericSkeleton } from '@landr/maestro';
const backgroundImageBaseStyles = css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
    object-position: center center;
    height: 100%;
    width: 100%;
`;

export const BackgroundImage = styled(Image)`
    ${backgroundImageBaseStyles};
`;

export const BackgroundSkeleton = styled(GenericSkeleton)`
    position: absolute;
    width: 100%;
    height: 100%;
`;
